import React from "react";

const InputSkeletonLogo = () => {
  return (
    <div className="input-skeleton-group">
      <div className="input-skeleton">
        <div className="input-skeleton__logo" />
      </div>
    </div>

  );
}

export default InputSkeletonLogo;